module.exports = __webpack_public_path__ + "img/78.385fbcc0.png";